const vi = {
  7000001: "Lưới",
  7000002: "Chiến lược lưới",
  7000003: "Lưới Spot",
  7000004: "Bộ dao động",
  7000005: "Mua Thấp Bán Cao",
  7000006: "Trọng tài theo chu kỳ",
  7000007: "Công cụ",
  7000008: "Giao dịch sao chép tương lai",
  7000009: "Sao chép giao dịch một cú nhấp để kiếm tiền cùng nhau",

  target_8: "Tài khoản chiến lược",
};

export default vi;
